import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function Caution(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <Circle cx="9" cy="9" r="9" fill="#00AB59" />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1462 5.07327C14.4922 5.43011 14.4835 5.99989 14.1266 6.34592L7.93913 12.3459C7.59003 12.6844 7.03517 12.6844 6.68607 12.3459L3.87357 9.61864C3.51673 9.27262 3.50796 8.70284 3.85399 8.346C4.20001 7.98916 4.76979 7.9804 5.12663 8.32642L7.3126 10.4461L12.8736 5.0537C13.2304 4.70767 13.8002 4.71644 14.1462 5.07327Z"
        fill="white"
      />
    </Svg>
  );
}

export default Caution;
